import { React, lazy, Suspense, useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { TableContext } from '../contexts/tableContext';
import styles from '../components/CancelTicket/CancelTicket.module.scss';

const EventCreateStepsSidebar = lazy(() =>
  import('../components/EventCreateStepsSidebar/EventCreateStepsSidebar')
);

export default function EventCreateStepsLayout() {
  const location = useLocation();
  const { bodyStyleNew, dashboardStyle } = useContext(TableContext);
  const isFormPreview = location.pathname === '/form-preview';

  return (
    <>
      {!isFormPreview && (
        <Suspense fallback={null}>
          <EventCreateStepsSidebar />
        </Suspense>
      )}
      <div className={styles[bodyStyleNew]}>
        <div className={isFormPreview ? styles.formPreviewFullWidth : styles[dashboardStyle]}>
          <Outlet />
        </div>
      </div>
    </>
  );
}
